<script setup lang="ts">
import type { Locales } from '@/services/types/api.types';
import { useField } from 'vee-validate';
import { computed, inject, type Ref } from 'vue';

// PROPS
const props = defineProps<{
  name: string;
  label: string;
  language_enabled: Locales[];
  disabled?: boolean;
  clearable?: boolean;
  maxLength?: number;
  autoGrow?: boolean;
}>();

// EMITS
const emit = defineEmits(['clear']);

// COMPUTED
const nameFr = computed(() => `${props.name}.fr`);
const nameEn = computed(() => `${props.name}.en`);

const { value: valueFr, errorMessage: errorMessageFr } = useField<string>(nameFr.value);
const { value: valueEn, errorMessage: errorMessageEn } = useField<string>(nameEn.value);

const editLocale = inject<Ref<Locales>>('editLocale');
</script>

<template>
  <q-input
    v-if="editLocale === 'fr'"
    v-model="valueFr"
    :label="`${props.label} (fr)`"
    v-bind="$attrs"
    :error="!!errorMessageFr"
    :error-message="errorMessageFr"
    :disable="props.disabled"
    :clearable="props.clearable"
    :maxlength="props.maxLength"
    :autogrow="props.autoGrow"
    @clear="emit('clear')"
  />
  <q-input
    v-else-if="editLocale === 'en'"
    v-model="valueEn"
    :label="`${props.label} (en)`"
    v-bind="$attrs"
    :error="!!errorMessageEn"
    :error-message="errorMessageEn"
    :disable="props.disabled"
    :clearable="props.clearable"
    :maxlength="props.maxLength"
    :autogrow="props.autoGrow"
    @clear="emit('clear')"
  />
  <q-banner class="text-white bg-red q-mb-sm" v-if="!editLocale">Missing editLocale injection</q-banner>
</template>
